import React from "react";
import {Field, useFormState} from "react-final-form";
import {useSelector} from "react-redux";
import {useIsShowMap} from "../../hooks/useIsShowMap";
import useSyncedField from "../../hooks/useSyncedField";

function FreeAdditionalServices() {
    const {values} = useFormState();
    const {features} = useSelector(state => state.orderOptions.data);
    const isShowMap = useIsShowMap(values);
    useSyncedField('freePlagiarismReport','int');
    useSyncedField('freeAbstractPage', 'int');
    useSyncedField('freeEditorCheck', 'int');

    return (isShowMap.freePlagiarismReport || isShowMap.freeAbstractPage || isShowMap.freeEditorCheck) ? (
        <div className="form-group">
            <div className="form-label">Free features</div>
            <div className="accordion-wrap">
                {isShowMap.freePlagiarismReport && (
                    <label className={`accordion-item checkbox-default ${values.freePlagiarismReport ? 'checked' : ''}`}>
                        <div className="accordion-title-wrap">
                            <div className="accordion-title">
                                <div className="accordion-title__icon"><img src="/_core/assets/themes/v5/assets/img/form3/srv-icon-new-1.svg" alt=""/></div>
                                <div className="accordion-title__right">
                                    <div className="accordion-title__group">
                                        <span>{features.freePlagiarismReport.label}</span>
                                    </div>
                                    <div className="srv-price">Free</div>
                                </div>
                            </div>
                            <div className="accordion-title-right">
                                <Field
                                    name="freePlagiarismReport"
                                    type="checkbox"
                                    component="input"
                                    className="checkbox-item"
                                    parse={v => v ? 1 : 0}
                                />
                                <span className="checkbox-default__checkmark">
                                    <div className="checkbox-default__checkmark-icon">
                                        <img src="/_core/assets/themes/v5/assets/img/form3/default-check-icon.svg" alt=""/>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div className="accordion-content">
                            <p>
                                Receive an official document with a detailed analysis of your work from a premium plagiarism detective system.
                            </p>
                        </div>
                    </label>
                )}

                {isShowMap.freeAbstractPage && (
                    <label className={`accordion-item checkbox-default ${values.freeAbstractPage ? 'checked' : ''}`}>
                        <div className="accordion-title-wrap">
                            <div className="accordion-title">
                                <div className="accordion-title__icon"><img src="/_core/assets/themes/v5/assets/img/form3/srv-icon-new-2.svg" alt=""/></div>
                                <div className="accordion-title__right">
                                    <div className="accordion-title__group">
                                        <span>{features.freeAbstractPage.label}</span>
                                    </div>
                                    <div className="srv-price">Free</div>
                                </div>
                            </div>
                            <div className="accordion-title-right">
                                <Field
                                    name="freeAbstractPage"
                                    type="checkbox"
                                    component="input"
                                    className="checkbox-item"
                                    parse={v => v ? 1 : 0}
                                />
                                <span className="checkbox-default__checkmark">
                                    <div className="checkbox-default__checkmark-icon">
                                        <img src="/_core/assets/themes/v5/assets/img/form3/default-check-icon.svg" alt=""/>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div className="accordion-content">
                            <p>
                                A concise summary (also called an executive summary) of the main points of your paper. It is highly recommended for the APA format.
                            </p>
                        </div>
                    </label>
                )}

                {isShowMap.freeEditorCheck && (
                    <label className={`accordion-item checkbox-default ${values.freeEditorCheck ? 'checked' : ''}`}>
                        <div className="accordion-title-wrap">
                            <div className="accordion-title">
                                <div className="accordion-title__icon"><img src="/_core/assets/themes/v5/assets/img/form3/srv-icon-new-3.svg" alt=""/></div>
                                <div className="accordion-title__right">
                                    <div className="accordion-title__group">
                                        <span>{features.freeEditorCheck.label}</span>
                                    </div>
                                    <div className="srv-price">Free</div>
                                </div>
                            </div>
                            <div className="accordion-title-right">
                                <Field
                                    name="freeEditorCheck"
                                    type="checkbox"
                                    component="input"
                                    className="checkbox-item"
                                    parse={v => v ? 1 : 0}
                                />
                                <span className="checkbox-default__checkmark">
                                    <div className="checkbox-default__checkmark-icon">
                                        <img src="/_core/assets/themes/v5/assets/img/form3/default-check-icon.svg" alt=""/>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div className="accordion-content">
                            <p>
                                A professional editor will check your pages for grammar, lexis, context, and format to make it unexceptionable.
                            </p>
                        </div>
                    </label>
                )}
            </div>
        </div>
    ) : '';
}

export default FreeAdditionalServices;
